// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2USjJ","insightsList":"newBusinessInsightsMenu_insightsList__dn7oM","active":"newBusinessInsightsMenu_active__1YhAs"};